import { Action } from 'redux';
import { LandingPage, Template, TemplateType, LandingPageTypeEnum } from '@dev/ee-api/ee-api-models';

import { TemplateListParams } from '@/services/ApiCategories/templates';

export interface StdLoadListInterface extends TemplateListParams, TemplateListState {}


export interface LoadTemplateStart extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_START,
    payload: {
        name: string;
        pageType: PageTypeEnum
    }
}

export interface LoadTemplateSuccess extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_SUCCESS,
    payload: {
        template: Template
    }
}

export interface LoadTemplateError extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_ERROR,
}
export interface LoadTemplateSubmitStart extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_SUBMIT_START,
    payload: {
        name: string;
        loadingTemplateFormSubmit: boolean;
        pageType: PageTypeEnum;
    }
}

export interface LoadTemplateSubmitSuccess extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_SUBMIT_SUCCESS,
    payload: {
        templateFormSubmit: Template;
        loadingTemplateFormSubmit: boolean
    }
}

export interface LoadTemplateSubmitError extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_SUBMIT_ERROR,
    payload: {
        loadingTemplateFormSubmit: boolean
    }
}
export interface LoadTemplateAlreadySubscribedStart extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_START,
    payload: {
        name: string;
        loadingTemplateAlreadySubscribed: boolean;
        pageType: PageTypeEnum;
    }
}

export interface LoadTemplateAlreadySubscribedSuccess extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_SUCCESS,
    payload: {
        templateAlreadySubscribed: Template;
        loadingTemplateAlreadySubscribed: boolean;
    }
}

export interface LoadTemplateAlreadySubscribedError extends Action {
    type: LandingPagesActionTypes.LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_ERROR,
    payload: {
        loadingTemplateAlreadySubscribed: boolean;
    }
}
export interface LoadListStartAction extends Action {
    type: '@@landingPageList/LOADING_START';
    payload: StdLoadListInterface;
}

export interface LoadListSuccessAction extends Action {
    type: '@@landingPageList/LOADING_SUCCESS';
    payload: StdLoadListInterface;
}

export interface LoadListErrorAction extends Action {
    type: '@@landingPageList/LOADING_ERROR';
    payload: StdLoadListInterface;
}

interface TemplateListState {
    loadingTemplates?: boolean;
    loadingTemplate?: boolean;
    loadingLandingPagesList?: boolean;
    landingPagesList?: LandingPage[];
    templatesList?: Template[];
    submitLandingPagesList?: Template[];
    alreadySubscribedLandingPagesList?: Template[];
    loadingSubmitLandingPages?: boolean;
    loadingAlreadySubscribedLandingPages?: boolean;
    templateAlreadySubscribed?: Template;
    templateFormSubmit?: Template;
    loadingTemplateFormSubmit?: boolean;
    loadingTemplateAlreadySubscribed?: boolean;
    limit?: number;
    page?: number;
    count?: number;
    tags?: Array<string>;
    templateTypes?: TemplateType[];
    UpdatingTemplate?: boolean;
    DeletingTemplate?: boolean;
    PreviewLoading?: boolean;
    templateSaving?: boolean;
    name?: string;
    template?: Template;
    templateObject?: Template;
    templatesToDelete?: Array<string>;
    pageToLoad?: any;
    ispublic?: boolean;
    removeScreenshot?: boolean;
    prevTemplateName?: string;
    changes?: Template;
    isInfinityScroll?: boolean;
    hasMoreTemplates?: boolean;
    hasMoreSubmitPages?: boolean;
    hasMoreAlreadySubscribedPages?: boolean;
    pageType?: PageTypeEnum;
}

export enum PageTypeEnum {
    DoubleOptIn = 'dpubleOptIn',
    FormSubmit = 'formSubmit',
    AlreadySubscribed = 'alreadySubscribed'
}

export enum LandingPagesActionTypes {
    LOADING_SUBMIT_LANDING_PAGES_START = '@@landingPageList/LOADING_SUBMIT_LANDING_PAGES_START',
    LOADING_SUBMIT_LANDING_PAGES_SUCCESS = '@@landingPageList/LOADING_SUBMIT_LANDING_PAGES_SUCCESS',
    LOADING_SUBMIT_LANDING_PAGES_ERROR = '@@landingPageList/LOADING_SUBMIT_LANDING_PAGES_ERROR',
    LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_START = '@@landingPageList/LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_START',
    LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_SUCCESS = '@@landingPageList/LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_SUCCESS',
    LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_ERROR = '@@landingPageList/LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_ERROR',
    LOADING_LANDING_PAGE_START = '@@landingPageList/LOADING_LANDING_PAGE_START',
    LOADING_LANDING_PAGE_SUCCESS = '@@landingPageList/LOADING_LANDING_PAGE_SUCCESS',
    LOADING_LANDING_PAGE_ERROR = '@@landingPageList/LOADING_LANDING_PAGE_ERROR',
    LOADING_LANDING_PAGE_SUBMIT_START = '@@landingPageList/LOADING_LANDING_PAGE_SUBMIT_START',
    LOADING_LANDING_PAGE_SUBMIT_SUCCESS = '@@landingPageList/LOADING_LANDING_PAGE_SUBMIT_SUCCESS',
    LOADING_LANDING_PAGE_SUBMIT_ERROR = '@@landingPageList/LOADING_LANDING_PAGE_SUBMIT_ERROR',
    LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_START = '@@landingPageList/LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_START',
    LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_SUCCESS = '@@landingPageList/LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_SUCCESS',
    LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_ERROR = '@@landingPageList/LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_ERROR',

    LOAD_LANDING_PAGES_LIST_START = '@@landingPageList/LOAD_LANDING_PAGES_LIST_START',
    LOAD_LANDING_PAGES_LIST_SUCCESS = '@@landingPageList/LOAD_LANDING_PAGES_LIST_SUCCESS',
    LOAD_LANDING_PAGES_LIST_ERROR = '@@landingPageList/LOAD_LANDING_PAGES_LIST_ERROR',
}

export type DeleteTemplateInterface = StdLoadListInterface;

export interface LoadSubmitLandingPagesStartAction extends Action {
    type: LandingPagesActionTypes.LOADING_SUBMIT_LANDING_PAGES_START;
    payload: StdLoadListInterface;
}

export interface LoadSubmitLandingPagesSuccessAction extends Action {
    type: LandingPagesActionTypes.LOADING_SUBMIT_LANDING_PAGES_SUCCESS;
    payload: StdLoadListInterface;
}

export interface LoadSubmitLandingPagesErrorAction extends Action {
    type: LandingPagesActionTypes.LOADING_SUBMIT_LANDING_PAGES_ERROR;
    payload: StdLoadListInterface;
}
export interface LoadAlreadySubscribedLandingPagesListStartAction extends Action {
    type: LandingPagesActionTypes.LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_START;
    payload: StdLoadListInterface;
}

export interface LoadAlreadySubscribedLandingPagesSuccessAction extends Action {
    type: LandingPagesActionTypes.LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_SUCCESS;
    payload: StdLoadListInterface;
}

export interface LoadAlreadySubscribedLandingPagesErrorAction extends Action {
    type: LandingPagesActionTypes.LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_ERROR;
    payload: StdLoadListInterface;
}
export interface templateDeleteStartAction extends Action {
    type: '@@landingPageList/DELETE_START';
    payload: DeleteTemplateInterface;
}

export interface templateDeleteSuccessAction extends Action {
    type: '@@landingPageList/DELETE_SUCCESS';
    payload: DeleteTemplateInterface;
}

export interface templateDeleteErrorAction extends Action {
    type: '@@landingPageList/DELETE_ERROR';
    payload: DeleteTemplateInterface;
}
export interface templateArrayDeleteStartAction extends Action {
    type: '@@landingPageList/DELETE_ARRAY_START';
    payload: DeleteTemplateInterface;
}
export interface templateArrayDeleteSuccessAction extends Action {
    type: '@@landingPageList/DELETE_ARRAY_SUCCESS';
    payload: DeleteTemplateInterface;
}
export interface templateArrayDeleteErrorAction extends Action {
    type: '@@landingPageList/DELETE_ARRAY_ERROR';
    payload: DeleteTemplateInterface;
}
export type PreviewTemplateInterface = TemplateListState;

export interface templatePreviewStartAction extends Action {
    type: '@@landingPageList/PREVIEW_START';
    payload: PreviewTemplateInterface;
}

export interface templatePreviewSuccessAction extends Action {
    type: '@@landingPageList/PREVIEW_SUCCESS';
    payload: PreviewTemplateInterface;
}

export interface templatePreviewErrorAction extends Action {
    type: '@@landingPageList/PREVIEW_ERROR';
    payload: PreviewTemplateInterface;
}
export type UpdateTemplateInterface = TemplateListState;

export interface templateUpdateStartAction extends Action {
    type: '@@landingPageList/UPDATE_START';
    payload: UpdateTemplateInterface;
}

export interface templateUpdateSuccessAction extends Action {
    type: '@@landingPageList/UPDATE_SUCCESS';
    payload: UpdateTemplateInterface;
}

export interface templateUpdateErrorAction extends Action {
    type: '@@landingPageList/UPDATE_ERROR';
    payload: UpdateTemplateInterface;
}

export type SaveTemplateInterface = TemplateListState;

export interface SaveTemplateStartAction extends Action {
    type: '@@landingPageList/SAVE_TEMPLATE_START';
    payload: SaveTemplateInterface;
}

export interface SaveTemplateSuccessAction extends Action {
    type: '@@landingPageList/SAVE_TEMPLATE_SUCCESS';
    payload: SaveTemplateInterface;
}

export interface SaveTemplateErrorAction extends Action {
    type: '@@landingPageList/SAVE_TEMPLATE_ERROR';
    payload: SaveTemplateInterface;
}

export type DownloadLandingPageInterface = TemplateListState;

export interface downloadLandingPageStartAction extends Action {
    type: '@@landingPageList/DOWNLOAD_LANDING_PAGE_START';
    payload: DownloadLandingPageInterface;
}

export interface downloadLandingPageSuccessAction extends Action {
    type: '@@landingPageList/DOWNLOAD_LANDING_PAGE_SUCCESS';
    payload: DownloadLandingPageInterface;
}

export interface downloadLandingPageErrorAction extends Action {
    type: '@@landingPageList/DOWNLOAD_LANDING_PAGE_ERROR';
    payload: DownloadLandingPageInterface;
}

export interface LoadLandingPagesListStartAction extends Action {
    type: LandingPagesActionTypes.LOAD_LANDING_PAGES_LIST_START;
    payload: {
        type: LandingPageTypeEnum;
        offset: number;
        limit: number;
    };
}
export interface LoadLandingPagesListSuccessAction extends Action {
    type: LandingPagesActionTypes.LOAD_LANDING_PAGES_LIST_SUCCESS;
    payload: {
        landingPagesList: LandingPage[];
    };
}

export interface LoadLandingPagesListErrorAction extends Action {
    type: LandingPagesActionTypes.LOAD_LANDING_PAGES_LIST_ERROR;
}

export { TemplateListState };
